<button
  bit-badge
  [style.color]="textColor"
  [style.background-color]="color"
  appA11yTitle="{{ organizationName }}"
  (click)="emitOnOrganizationClicked()"
>
  {{ organizationName | ellipsis: 13 }}
</button>
